import React, { useState, useRef } from "react";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  getXanoAuthEmailToken,
  getXanoAuthToken,
  setOnboardingPhase,
  xanoUserSignup,
} from "../../redux/actions/authentication";
import { fetchIsUserFromBetaProduct } from "../../redux/actions/personaliseCourse";
import { setActivationPhase } from "../../redux/actions/contentPayer";
import { SET_IS_ACTIVATION } from "../../redux/actions/types";
import { toast } from "react-toastify";
import GoogleLogin from "react-google-login";
import Spinner from "../../components/Spinner";
import CountryCode from "../LandingPage/CountryCode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { AnimatePresence, motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import PasswordResetModal from "./PasswordResetModal";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";

const LoginForm = ({authResponse, isLinkedInLoading , navigateLinkedInLogin, formSwiperRef, dummyRef, handleFormSlide , loginEmailRef}) => {

  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isPhoneError, setPhoneError] = useState(false);
  const [isEmailError, setEmailError] = useState(false);
  const [searchParams] = useSearchParams();
  const [formData, setFromData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    otp: "",
  });

  const [isLoginWithEmail, setIsLoginWithEmail] = useState(false);
  const [loginToggle, setLoginToggle] = useState(false);
  const [emailFormData, setEmailFormData] = useState({
    email: "",
    password: "",
  });
  const [isPasswordResetModalEnabled, setIsPasswordResetModalEnabled] =
    useState(false);

 

  const onChange = (e) => {
    setPhoneError(false);
    setEmailError(false);
    setFromData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChangeEmailFormData = (e) => {
    setEmailFormData({ ...emailFormData, [e.target.name]: e.target.value });
  };

  console.log("formData", formData);
  const onSubmit = async () => {
    setIsLoading(true);
    if (
      formData.name !== "" &&
      formData.email !== "" &&
      formData.password !== ""
    ) {
      Mixpanel.track(Constants.Mixpanel.LANDING_PAGE_SIGNUP_WITH_EMAIL_CLICKED);
      await dispatch(
        xanoUserSignup(
          { ...formData, phone: "" },
          (successObj) => {
            Mixpanel.identify(successObj?.email);
            Mixpanel.track(Constants.Mixpanel.LOG_IN, {
                distinct_id: successObj?.email,
            });
            Mixpanel.people.set({
                $first_name: successObj?.first_name,
                $last_name: successObj?.last_name,
                $email: successObj?.email,
                $name: successObj?.name,
            });
            if (successObj?.result !== "failed") {
              dispatch(
                fetchIsUserFromBetaProduct(
                  (res) => {
                    console.log("monday", res);
                    if (
                      res?.data?.is_ninjacurate_user ||
                      res?.data?.ninjacurate_is_paid
                    ) {
                      dispatch(
                        setOnboardingPhase(
                          (res1) => {},
                          (err1) => {}
                        )
                      );
                      dispatch(
                        setActivationPhase((successObj) =>
                          dispatch({ type: SET_IS_ACTIVATION, payload: false })
                        )
                      );
                    }
                  },
                  (err) => {}
                )
              );
            }

            if (successObj.number_verification) {
              navigate(
                location?.state?.from?.pathname
                  ? location?.state?.from?.pathname
                  : "/courses",
                { replace: true }
              );
            } else {
              if (successObj?.show_toast) {
                toast.error(successObj?.message);
                if (successObj?.message === "Phone already in use") {
                  setPhoneError(true);
                } else if (successObj?.message === "Email already in use") {
                  setEmailError(true);
                }
                setIsLoading(false);
              } else {
                const userId = successObj?.id;
                //sendUtmData(userId);
                navigate("/verification");
              }
            }
          },
          (errObj) => {
            toast.error(errObj?.message);
            setIsLoading(false);
          }
        )
      );
    } else {
      setIsLoading(false);
      if (formData.name === "")
        return toast.error('"Full Name" field is empty!!');
      if (formData.email === "") return toast.error('"Email" field is empty!!');
      if (formData.password === "")
        return toast.error('"Password" field is empty!!');
    }
  };

  const emailSignIn = () => {
    Mixpanel.track(Constants.Mixpanel.LANDING_PAGE_LOGIN_WITH_EMAIL_CLICKED);
    dispatch(
      getXanoAuthEmailToken(
        emailFormData.email,
        emailFormData.password,
        (successObj) => {
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          //   Mixpanel.identify(successObj?.email);
          //   Mixpanel.track(Constants.Mixpanel.LOG_IN, {
          //     distinct_id: successObj?.email,
          //   });
          //   Mixpanel.people.set({
          //     $first_name: successObj?.first_name,
          //     $last_name: successObj?.last_name,
          //   });

          if (successObj?.result !== "failed") {
            dispatch(
              fetchIsUserFromBetaProduct(
                (res) => {
                  console.log("monday", res);
                  if (
                    res?.data?.is_ninjacurate_user ||
                    res?.data?.ninjacurate_is_paid
                  ) {
                    dispatch(
                      setOnboardingPhase(
                        (res1) => {},
                        (err1) => {}
                      )
                    );
                    dispatch(
                      setActivationPhase((successObj) =>
                        dispatch({ type: SET_IS_ACTIVATION, payload: false })
                      )
                    );
                  }
                },
                (err) => {}
              )
            );
          }
          if (successObj.number_verification) {
            if (searchParams.get("course")) {
              navigate(`/course/${searchParams?.get("course")}`);
            } else {
              navigate(
                location?.state?.from?.pathname
                  ? location?.state?.from?.pathname
                  : "/courses",
                { replace: true }
              );
            }
          } else {
            // ReactPixel.trackSingle("333999584825866", "Lead");
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
            } else {
              if (searchParams.get("course")) {
                navigate(`/verification/${searchParams?.get("course")}`);
              } else {
                navigate("/verification");
              }
            }
          }
        },
        (errorObj) => {
          if (errorObj.response.data.message === "Invalid password syntax.") {
            toast.error("Try Login with Google/Facebook");
          } else {
            toast.error("Enter Valid Credentials");
          }
        }
      )
    );
  };




 

  return (
    <div className="w-full login-form-autofill relative" >
      <div className="absolute -top-20" ref={dummyRef}></div>
      <style>{`
        .login-form-autofill input:-webkit-autofill,
        .login-form-autofill input:-webkit-autofill:hover,
        .login-form-autofill input:-webkit-autofill:focus {
          -webkit-text-fill-color: #121212 !important;
          caret-color: #121212;
          box-shadow: 0 0 0px 1000px #ffffff inset !important;
          transition: background-color 9999s ease-in-out 0s;
        }
      `}</style>
      <div className="mx-auto flex w-full flex-col items-center justify-center rounded-[24px] bg-white py-6 px-4 text-black" style={{
  boxShadow: "0px 0px 28px 0px rgba(0, 0, 0, 0.5)"
}}>
        <h2 className=" md:px-10 bg-gradient-to-r from-[#70AEFF] to-[#0041C2] bg-clip-text text-center text-[24px] md:text-[32px] font-semibold leading-[130%] text-transparent">
        Start Building Your Dream Career In{" "}
          <span className="font-extrabold italic"> 30 seconds </span>
        </h2>
        {isLoading ? (
          <Spinner />
        ) : (
          <GoogleLogin
            clientId={XANO_GOOGLE_CLIENT_ID}
            render={(renderProps) => {
              return (
                <button
                  onClick={renderProps.onClick}
                  className="relative mt-6 h-12  w-full rounded-lg bg-[#3B82F6] py-3 text-[16px] font-semibold text-white"
                >
                  <div className="absolute inset-y-0 left-3 my-auto h-7 w-7 rounded-full bg-white">
                    <img
                      src="https://assets.learntube.ai/files/Onboarding_Revamp/image%20479.png?updatedAt=1694429827511"
                      width={28}
                      height={28}
                      alt="google icon"
                    />
                  </div>
                  <p className="mx-auto text-center font-semibold text-white">
                    Continue with Google
                  </p>
                </button>
              );
            }}
            onSuccess={(e)=> authResponse(e , setIsGoogleLoading)}
            onFailure={(e)=> authResponse(e , setIsGoogleLoading)}
            cookiePolicy={"single_host_origin"}
          />
        )}

        <div
          className="relative mt-3 h-12  w-full rounded-lg border-[1px] border-[#285AAC]/80 bg-white py-3 text-[16px] font-semibold text-white "
          onClick={navigateLinkedInLogin}
          
        >
          <div className="absolute inset-y-0 left-3 my-auto h-7 w-7 rounded-full bg-white">
            <img
              src="https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400"
              width={28}
              height={28}
              alt="google icon"
            />
          </div>
          <p className="mx-auto text-center font-semibold text-[#285AAC]/80 ">
            Continue With LinkedIn
          </p>
        </div>

        <div className="mt-3 md:mt-4 flex  w-full items-center justify-center">
          <div className="flex-1 border-[0.5px] border-black/20" />
          <div className="mx-2 text-[14px] text-black/20 ">Or</div>
          <div className="flex-1 border-[0.5px] border-black/20" />
        </div>
        <Swiper
          ref={formSwiperRef}
          modules={[]}
          spaceBetween={8}
          slidesPerView="1"
          loop={false}
          speed={800}
          allowTouchMove={false}
          className="mt-3 md:mt-4 w-full"
        >
          <SwiperSlide key={0} className="">
            <div className="mx-auto w-[99%] text-white">
              <div className="">
                <label
                  htmlFor="name"
                  className="text-[14px] md:text-[18px] md:font-medium text-[#121212]/70 "
                >
                  Your Name<span className="text-[#E06064]">*</span>
                </label>
                <input
                  id="name"
                  name="name"
                  onChange={onChange}
                  type="text"
                  placeholder="For e.g., John Doe"
                  required
                  className="mt-1 h-11 w-full appearance-none rounded-lg border border-[#121212]/30 px-3 py-2 text-[16px] text-white/50 text-[#121212] placeholder:text-sm placeholder:font-semibold placeholder:text-[#121212]/30 focus:z-10 focus:shadow-[0_0_4px_0_#4285F4] focus:outline-none focus:ring-[#4285F4]"
                />
              </div>
              <div className="mt-4 ">
                <label
                  htmlFor="email-address"
                  className="text-[14px] md:text-[18px] md:font-medium text-[#121212]/70"
                >
                  Email<span className="text-[#E06064]">*</span>
                  {isEmailError && (
                    <span className="ml-1 text-[14px] font-normal italic text-[#E06064] ">
                      Already in use, try to login
                    </span>
                  )}
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  onChange={onChange}
                  placeholder="For e.g., johndoe123@gmail.com"
                  required
                  className={`mt-1 h-11 w-full appearance-none rounded-lg border border-[#121212]/30 px-3 py-2 text-white/50 placeholder:text-sm placeholder:font-semibold placeholder:text-[#121212]/30 focus:z-10 focus:shadow-[0_0_4px_0_#4285F4] focus:outline-none focus:ring-[#4285F4]  ${
                    isEmailError
                      ? "border-1 border-[#E06064] text-[#E06064]"
                      : "text-[#121212]"
                  }  text-[16px]`}
                />
              </div>
              <AnimatePresence mode="wait" initial={false}>
                {formData?.email !== "" && formData?.name !== "" && (
                  <motion.div
                    key="password-field"
                    layout
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    transition={{
                      type: "spring",
                      stiffness: 380,
                      damping: 28,
                      mass: 0.6,
                    }}
                    className="max-h-[200px] w-full"
                    style={{ willChange: "transform, opacity" }}
                  >
                    <div className="mt-4">
                      <label
                        htmlFor="password"
                        className="text-[14px]  md:text-[18px] md:font-medium text-[#121212]/70"
                      >
                        Password<span className="text-[#E06064]">*</span>
                      </label>
                      <div className="relative">
                        <input
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          onChange={onChange}
                          placeholder="Password"
                          required
                          className="mt-1 h-11 w-full appearance-none rounded-lg border border-[#121212]/30 px-3 py-2 pr-10 text-[16px] text-white/50 text-[#121212] placeholder:text-sm placeholder:font-semibold placeholder:text-[#121212]/30 focus:z-10 focus:shadow-[0_0_4px_0_#4285F4] focus:outline-none focus:ring-[#4285F4]"
                        />
                        <button
                          type="button"
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute inset-y-0 right-3 my-auto h-5 w-5 text-[#121212]/50 hover:text-[#121212]/70"
                          tabIndex={0}
                        >
                          {/* Eye icon */}
                          {showPassword ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l2.27 2.27A12.27 12.27 0 0 0 1.72 12c1.58 3.92 5.52 7 10.28 7 2.06 0 3.98-.57 5.6-1.56l2.87 2.87a.75.75 0 1 0 1.06-1.06l-18-18zM12 7.5c.64 0 1.24.17 1.76.46l-1.9 1.9a2.25 2.25 0 0 0-1.26 1.26l-1.9 1.9A4.5 4.5 0 0 1 12 7.5z" />
                              <path d="M20.86 15.27a12.24 12.24 0 0 0 1.42-3.27C20.7 8.08 16.76 5 12 5c-.98 0-1.92.13-2.8.38l2.16 2.16A4.5 4.5 0 0 1 16.46 12c0 .64-.13 1.25-.38 1.8l2.16 2.16c.24-.18.47-.38.7-.59.71-.67 1.33-1.43 1.92-2.1z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M12 5c4.76 0 8.7 3.08 10.56 7.27-.6 1.47-1.5 2.94-2.62 4.1C18.9 18.74 15.6 20 12 20c-4.76 0-8.7-3.08-10.56-7.27C3.3 8.08 7.24 5 12 5zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
              <div
                className={`mt-5 w-full rounded-lg px-[2px] pb-[2px] ${
                  formData?.email !== "" &&
                  formData?.name !== "" &&
                  formData?.password !== ""
                    ? "opacity-100"
                    : "opacity-50"
                }`}
                style={{
                  background:
                    "linear-gradient(to right, #8BD845 0%, #C5E2AB 100%)",
                }}
              >
                <button
                  className="w-full rounded-lg bg-[#7FC241] py-[10px] text-[18px] md:text-[20px] md:font-bold font-semibold text-[#121212]"
                  disabled={isLoading}
                  onClick={onSubmit}
                >
                  {isLoading ? (
                    "Registering..."
                  ) : (
                    <>
                      Let’s Get Started For Free!
                      <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
                    </>
                  )}
                </button>
              </div>
              <div className="mt-1 text-center text-[14px] md:text-[16px]  text-[#121212]/50">
                Already have an account?
                <span
                  className="ml-1 md:ml-2 cursor-pointer font-semibold text-[#7FC241]"
                  onClick={()=> handleFormSlide(formSwiperRef, 0)}
                >
                  Login In With Email
                </span>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide key={1} className="">
            <div className="mx-auto w-[99%] text-white">
              <div className="">
                <label
                  htmlFor="email-address"
                  className="text-[14px] md:text-[18px] md:font-medium text-[#121212]/70"
                >
                  Email<span className="text-[#E06064]">*</span>
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  ref={loginEmailRef}
                  onChange={onChangeEmailFormData}
                  placeholder="For e.g., johndoe123@gmail.com"
                  required
                  className={`mt-1 h-11 w-full appearance-none rounded-lg border border-[#121212]/30 px-3 py-2 text-white/50 placeholder:text-sm placeholder:font-semibold placeholder:text-[#121212]/30 focus:z-10 focus:shadow-[0_0_4px_0_#4285F4] focus:outline-none focus:ring-[#4285F4]  ${
                    isEmailError
                      ? "border-1 border-[#E06064] text-[#E06064]"
                      : "text-[#121212]"
                  }  text-[16px]`}
                />
              </div>
              <div className="mt-4">
                <label
                  htmlFor="password"
                  className="flex items-center justify-between text-[14px] md:text-[18px] md:font-medium text-[#121212]/70"
                >
                  <span>
                    Password<span className="text-[#E06064]">*</span>
                  </span>
                  <span
                    className="cursor-pointer text-[14px] font-medium"
                    onClick={() => setIsPasswordResetModalEnabled(true)}
                  >
                    Forgot Password?
                  </span>
                </label>
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    onChange={onChangeEmailFormData}
                    placeholder="Password"
                    required
                    className="mt-1 h-11 w-full appearance-none rounded-lg border border-[#121212]/30 px-3 py-2 pr-10 text-[16px] text-white/50 text-[#121212] placeholder:text-sm placeholder:font-semibold placeholder:text-[#121212]/30 focus:z-10 focus:shadow-[0_0_4px_0_#4285F4] focus:outline-none focus:ring-[#4285F4]"
                  />
                  <button
                    type="button"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-3 my-auto h-5 w-5 text-[#121212]/50 hover:text-[#121212]/70"
                    tabIndex={0}
                  >
                    {/* Eye icon */}
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l2.27 2.27A12.27 12.27 0 0 0 1.72 12c1.58 3.92 5.52 7 10.28 7 2.06 0 3.98-.57 5.6-1.56l2.87 2.87a.75.75 0 1 0 1.06-1.06l-18-18zM12 7.5c.64 0 1.24.17 1.76.46l-1.9 1.9a2.25 2.25 0 0 0-1.26 1.26l-1.9 1.9A4.5 4.5 0 0 1 12 7.5z" />
                        <path d="M20.86 15.27a12.24 12.24 0 0 0 1.42-3.27C20.7 8.08 16.76 5 12 5c-.98 0-1.92.13-2.8.38l2.16 2.16A4.5 4.5 0 0 1 16.46 12c0 .64-.13 1.25-.38 1.8l2.16 2.16c.24-.18.47-.38.7-.59.71-.67 1.33-1.43 1.92-2.1z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 5c4.76 0 8.7 3.08 10.56 7.27-.6 1.47-1.5 2.94-2.62 4.1C18.9 18.74 15.6 20 12 20c-4.76 0-8.7-3.08-10.56-7.27C3.3 8.08 7.24 5 12 5zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              <div
                className={`mt-5 w-full rounded-lg px-[2px] pb-[2px] ${
                  emailFormData?.email !== "" && emailFormData?.password !== ""
                    ? "opacity-100"
                    : "opacity-50"
                }`}
                style={{
                  background:
                    "linear-gradient(to right, #8BD845 0%, #C5E2AB 100%)",
                }}
              >
                <button
                  className="w-full rounded-lg bg-[#7FC241] py-[10px] text-[18px] md:text-[20px] md:font-bold font-semibold text-[#121212]"
                  disabled={isLoading}
                  onClick={emailSignIn}
                >
                  {isLoading ? (
                    "Registering..."
                  ) : (
                    <>
                      Log In
                      <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
                    </>
                  )}
                </button>
              </div>
              <div className="mt-1 text-center text-[14px] md:text-[16px]  text-[#121212]/50">
                Don’t have an account?
                <span
                  className="ml-1 md:ml-2 cursor-pointer font-semibold text-[#7FC241]"
                  onClick={()=> handleFormSlide(formSwiperRef, 1)}
                >
                  Sign Up Now
                </span>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <PasswordResetModal
        isModalEnabled={isPasswordResetModalEnabled}
        setIsModalEnabled={setIsPasswordResetModalEnabled}
      />
    </div>
  );
};

export default LoginForm;
